import React from 'react'
import styles, { layout } from '../styles'

const NotFound = () => {
  return (
    <div className={`${layout.section} ${styles.flexCenter}`}>
      <h1 className='text-2xl'>Page not found or the server is down</h1>
    </div>
  )
}

export default NotFound
